// Copyright (c) Docugami, Inc. All rights reserved.

import { FeatureFlags, getFeatureFlagName } from "store/featureFlags/types";
import { setFeatureFlag } from 'store/featureFlags/actions';
import { Toggle } from "@fluentui/react";
import { useFeatureFlag } from 'hooks/FeatureFlags';
import { Telemetry } from 'telemetry/TelemetryManager';
import { FeatureFlagToggleSchema, TelemetryEvent } from 'telemetry/TelemetryEvents';
import { useAppDispatch } from 'hooks/redux';

export interface FeatureFlagToggleProps {
    featureFlag: FeatureFlags
    label: string
    disabled?: boolean
}

/**
 * A toggle backed by a feature flag's underlying value
 * @param props
 */
export const FeatureFlagToggle = (props: FeatureFlagToggleProps): JSX.Element => {
    const isEnabled = useFeatureFlag(props.featureFlag);
    const dispatch = useAppDispatch();

    function onChange() {
        const enabled = !isEnabled;
        Telemetry.trackEvent<FeatureFlagToggleSchema>({
            featureFlag: props.featureFlag,
            enabled: enabled,
            eventName: TelemetryEvent.FeatureFlagToggle
        });
        dispatch(setFeatureFlag(props.featureFlag, enabled));
    }

    return (
        <Toggle
            key={getFeatureFlagName(props.featureFlag)}
            onText="Enabled"
            offText="Disabled"
            checked={isEnabled}
            onChange={() => onChange()}
            label={props.label}
            disabled={!!props.disabled} />
    );
}
